<template>
  <div id="updateBlacklist">
    <DForm :formItems="searchFormItems" :model="queryModule" label-width="5em">
      <template #actions>
        <el-form-item label-width="0">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="searchList"
          >
            查询
          </el-button>
        </el-form-item>
      </template>
    </DForm>
    <DTable
      :data="tableList"
      :tableItems="tableItems"
      :pageConfig="pageConfig"
      border
      stripe
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <template #header>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-has="'add'"
          @click="addEditBtn('add')"
        >
          新增
        </el-button>
      </template>
      <template #appName="{ row }">
        <span>{{ row.appName || row.name || "-" }}</span>
      </template>
      <template #packageName="{ row }">
        <span>{{
          row.packageName || row.appPackageName || row.pname || "-"
        }}</span>
      </template>
      <template #customerId="{ row }">
        <span>{{ row.customerId || row.cusNo || "-" }}</span>
      </template>
      <template #channelId="{ row }">
        <span>{{ row.channelId || row.channelName || "-" }}</span>
      </template>
      <template #projectId="{ row }">
        <span>{{ formatProjectIds(row) }}</span>
      </template>
      <template #remarks="{ row }">
        <span>{{ row.remarks || row.remark || "-" }}</span>
      </template>
      <template #actions="{ row }">
        <div class="table-actions">
          <el-button
            type="text"
            v-has="'edit'"
            @click="addEditBtn('edit', row)"
          >
            编辑
          </el-button>
          <el-button type="text" v-has="'delete'" @click="handleDelete(row)">
            删除
          </el-button>
        </div>
      </template>
    </DTable>
    <AddEditDialog
      ref="addEditDialog"
      :rowData="currentRow"
      :dialogName="dialogName"
      @submitBtn="handleSubmit"
    />
  </div>
</template>

<script>
import { getProJectList } from "@/api/ozBlockConf";
import AddEditDialog from "./components/addEditDialog.vue";
import { addRecord, deleteRecord, editRecord, getList } from "./api";

export default {
  name: "updateBlacklist",
  components: {
    AddEditDialog,
  },
  computed: {
    searchFormItems() {
      return [
        {
          label: "客户号",
          prop: "customerId",
          type: "Select",
          span: 4,
          props: {
            filterable: true,
            clearable: true,
            options: this.customerList.map((item) => ({
              label: item.cusNo,
              value: item.cusNo,
            })),
          },
          events: {
            change: this.handleCustomerChange,
          },
        },
        {
          label: "渠道号",
          prop: "channelId",
          type: "Select",
          span: 4,
          props: {
            filterable: true,
            clearable: true,
            disabled: !this.queryModule.customerId,
            options: this.channelList.map((item) => ({
              label: item.channelName,
              value: item.channelName,
            })),
          },
          events: {
            change: this.handleChannelChange,
          },
        },
        {
          label: "项目号",
          prop: "projectId",
          type: "Select",
          span: 4,
          props: {
            filterable: true,
            clearable: true,
            disabled: !this.queryModule.channelId,
            options: this.projectList.map((item) => ({
              label: item.projectName,
              value: item.projectName,
            })),
          },
        },
        {
          label: "应用名称",
          prop: "appName",
          type: "Input",
          span: 4,
          props: {
            clearable: true,
          },
          events: {
            "keyup.enter": this.searchList,
          },
        },
        {
          prop: "actions",
          span: 2,
          isSlot: true,
          labelShow: false,
        },
      ];
    },
    tableItems() {
      return [
        { label: "应用", prop: "appName", isSlot: true },
        { label: "包名", prop: "packageName", isSlot: true },
        { label: "客户号", prop: "customerId", isSlot: true },
        { label: "渠道号", prop: "channelId", isSlot: true },
        { label: "项目号", prop: "projectId", isSlot: true },
        { label: "备注", prop: "remarks", isSlot: true },
        { label: "创建时间", prop: "createTime", width: 160 },
        { label: "修改时间", prop: "modifyTime", width: 160 },
        {
          label: "操作",
          prop: "actions",
          isSlot: true,
          width: 160,
          fixed: "right",
        },
      ];
    },
    pageConfig() {
      return {
        page: this.queryModule.page,
        size: this.queryModule.size,
        total: this.queryModule.total,
      };
    },
  },
  data() {
    return {
      customerList: [],
      channelList: [],
      projectList: [],
      dialogName: "",
      currentRow: {},
      queryModule: {
        page: 1,
        size: 10,
        total: 0,
        customerId: "",
        channelId: "",
        projectId: "",
        appName: "",
      },
      tableList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.customerList = await this.getOptions({ type: 1 });
      this.getTableList();
    },
    async getOptions(params) {
      const res = await getProJectList({ page: 1, size: 3000, ...params });
      if (res && res.code === 0) {
        return res.data.list || [];
      }
      return [];
    },
    async handleCustomerChange(value) {
      this.queryModule.channelId = "";
      this.queryModule.projectId = "";
      this.channelList = [];
      this.projectList = [];
      if (!value) {
        return;
      }
      this.channelList = await this.getOptions({
        cusNo: value,
        type: 2,
      });
    },
    async handleChannelChange(value) {
      this.queryModule.projectId = "";
      this.projectList = [];
      if (!value || !this.queryModule.customerId) {
        return;
      }
      this.projectList = await this.getOptions({
        cusNo: this.queryModule.customerId,
        channelName: value,
        type: 3,
      });
    },
    searchList() {
      this.queryModule.page = 1;
      this.getTableList();
    },
    handleCurrentChange(page) {
      this.queryModule.page = page;
      this.getTableList();
    },
    handleSizeChange(size) {
      this.queryModule.size = size;
      this.queryModule.page = 1;
      this.getTableList();
    },
    getTableList() {
      const params = {
        page: this.queryModule.page,
        size: this.queryModule.size,
        count: true,
        customerId: this.queryModule.customerId,
        channelId: this.queryModule.channelId,
        projectId: this.queryModule.projectId,
        appName: this.queryModule.appName,
      };
      getList(params).then((res) => {
        if (!res) {
          return;
        }
        if (res.code === 0) {
          const { list = [], total = 0 } = res.data || {};
          this.tableList = list;
          this.queryModule.total = total;
        }
      });
    },
    addEditBtn(type, row) {
      this.dialogName = type === "add" ? "新增" : "编辑";
      this.currentRow = type === "add" ? {} : { ...row };
      this.$nextTick(() => {
        this.$refs.addEditDialog.init();
      });
    },
    handleSubmit(isAdd, data) {
      const request = isAdd ? addRecord : editRecord;
      request(data).then((res) => {
        if (!res) {
          return;
        }
        if (res.code === 0) {
          this.$message.success(res.msg || `${isAdd ? "新增" : "编辑"}成功`);
          this.getTableList();
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteRecord({ id: row.id }).then((res) => {
            if (!res) {
              return;
            }
            if (res.code === 0) {
              this.$message.success("删除成功");
              this.getTableList();
            }
          });
        })
        .catch(() => {});
    },
    formatProjectIds(row) {
      if (Array.isArray(row.projectIds) && row.projectIds.length) {
        return row.projectIds.join(", ");
      }
      return row.projectId || row.projectName || "-";
    },
  },
};
</script>

<style scoped lang="scss">
#updateBlacklist {
  .table-actions {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
